import { render } from "./ProcesarPago.vue?vue&type=template&id=79cb4168"
import script from "./ProcesarPago.vue?vue&type=script&lang=js"
export * from "./ProcesarPago.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__